<div class="h-full flex flex-col">
  <app-site-header
    [showCta]="isSitePage"
    class="z-50"
    [ngClass]="isSitePage ? 'sticky top-0' : 'fixed inset-x-0 top-0'"
  ></app-site-header>
  <app-notification></app-notification>
  <div class="relative h-full overflow-hidden">
    @if (isLoading$ | async) {
      <app-spinner></app-spinner>
    }
    <router-outlet></router-outlet>
  </div>
</div>
<app-chat></app-chat>
